import React from "react";
import Typewriter from "typewriter-effect";
import { Wrapper, Title } from "./Cover.styled";

const Cover = () => (
  <Wrapper>
    <Title>
      <h1>
        <Typewriter
          options={{
            strings: [
              "Happy Birthday My Love",
              "Sobrang proud ako sayo Love, sa lahat ng narating mo ngayon",
              "More Blessings to come at more candles to blow..",
              "Hmmm..",
            ],
            autoStart: true,
            loop: true,
          }}
        />
      </h1>
    </Title>
  </Wrapper>
);

export default Cover;
